import React, { useState } from "react";
import { Box, Grid } from "@mui/material";
import jss from '../../pages/flight/FlightCommonJss'
import FlightControlJobs from '../../pages/flight/FlightControlJobs';
import FlightControlLogs from '../../pages/flight/FlightControlLogs';
import JobSettings from '../../pages/flight/JobSettings';
import FlightService from "../../services/FlightService";
import JobLog from "./JobLog";


function FlightControl(props) {

	const [selectedFlightJob, setSelectedFlightJob] = React.useState(null);
	const [selectedFlightJobLog, setSelectedFlightJobLog] = React.useState(null);
	const [newFlightJob, setNewFlightJob] = React.useState(null);
	const [runFlightJob, setRunFlightJob] = React.useState(null);
	const [loading, setLoading] = React.useState(true);
	const [jobLogLoading, setJobLoading] = useState(true);
	const [showJobDetails, setShowJobDetails] = React.useState(false);
	const [showJobCreateComponent, setShowJobCreateComponent] = React.useState(false);

	const handleJobClick = (selectedFlightJob) => {
		setSelectedFlightJob(selectedFlightJob);
	};

	const handleJobLogClick = (selectedFlightJobLog) => {
		console.log
		setSelectedFlightJobLog(selectedFlightJobLog);
	}

	const handleDataLoaded = (loadedData) => {
		setLoading(false);
	};

	const handleJobLogLoaded = (loadedJobLogs) => {
		setJobLoading(false);
	}

	const handleAddJob = () => {
		setShowJobDetails((prev) => !prev);
	};
	const removeFromTable = (flightJobId) => {
		setSelectedFlightJob(prevFlights => prevFlights.filter(flightJob => flightJob.id !== flightJobId));
	  };

	const handleSaveFlightJob = async (flightJob) => {
		try {
			if (flightJob.id) {
				const response = await FlightService.updateFlightJob(flightJob.id, flightJob);
				console.log('Flight job updated:', response);
			} else {
				const response = await FlightService.createFlightJob(flightJob);
				setNewFlightJob(flightJob);
				// const job = await FlightService.runFlightJob(response.id, jobData);
				// const executeJob = await FlightService.executeFlightJob(job.id);
			}
		} catch (error) {
			console.error('Error saving flight job:', error);
		}
	}

	const handleRun = async (jobLog) => {
		const response  = await FlightService.executeDailyLightSpeedJob(jobLog.id);
		handleJobLogLoaded(response);
		console.log('Execute Job response', response);
	}

	return (
		<Box sx={{ py: 2 }}>
			<Grid container spacing={2}>
				{/* Title */}
				<Grid item xs={12}>
					<Box sx={jss.title}>Flight Control Page</Box>
				</Grid>

				{/* FlightControlJobs */}
				<Grid item xs={12} sm={4}>
					<FlightControlJobs
						onJobClick={handleJobClick}
						onDataLoaded={handleDataLoaded}
						/>
				</Grid>

				{/* FlightControlLogs */}
				<Grid item xs={12} sm={4}>
					<FlightControlLogs
						onJobLogClick={handleJobLogClick}
						onLoadedJobLogData={handleJobLogLoaded}
						/>
				</Grid>

				{/* FlightControlLogs and JobSettings */}
				<Grid item xs={12} sm={4}>
					{/* JobSettings */}
					{selectedFlightJob && selectedFlightJob !== null && !loading && (
						<JobSettings
							selectedFlightJob={selectedFlightJob}
							onSave={handleSaveFlightJob}
							onRun={handleRun}
							onDelete={removeFromTable}
							/>
					)}

					{/* JobLog */}
					{selectedFlightJobLog && selectedFlightJobLog !== null && !jobLogLoading && (
						<JobLog
							selectedFlightJobLog={selectedFlightJobLog}
							/>
					)}
				</Grid>
			</Grid>
		</Box>
	)
}

export default FlightControl